/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Distribute_DescriptionInputs */

const en_landing_step_distribute_description = /** @type {(inputs: Landing_Step_Distribute_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arm your desks with real-time synthesis of market signals and proprietary alpha to win the first call.`)
};

/**
* | output |
* | --- |
* | "Arm your desks with real-time synthesis of market signals and proprietary alpha to win the first call." |
*
* @param {Landing_Step_Distribute_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_distribute_description = /** @type {((inputs?: Landing_Step_Distribute_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Distribute_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_distribute_description(inputs)
});